// extracted by mini-css-extract-plugin
module.exports = {"container":"sz-z","disabled":"tz-z"};